import React from 'react';
import {Link} from 'react-router-dom';
import { IonContent, IonHeader, IonTitle, IonToolbar, IonItem, IonLabel, IonInput, IonRow, IonCol, IonGrid, IonText, IonButton, IonNote, IonButtons  } from '@ionic/react';
import './Recuperar2.css';

const Recuperar2: React.FC = () => {
  return (
    <IonContent className='blackBG'>
      <IonHeader>
        <IonToolbar className='toolbarTrans'>
          <IonButtons slot="end" className='btnCloseRecuperar'>
            <IonButton>
              <img src='./assets/img/cerrar.png' alt=''/>
            </IonButton>
          </IonButtons>
        </IonToolbar>
        <IonToolbar className='toolbarTrans'>
          <IonTitle className='ion-text-center'>
            <img src='./assets/carnot_logo.png' className='imgRecuperar' alt=""/>
          </IonTitle>
        </IonToolbar>
        <IonText color="primary">
            <h1 className='textRecuperaTitle'>Recupere su contraseña</h1>
        </IonText>
      </IonHeader>
      <IonGrid>
        <IonRow>
          <IonCol size-md="2"></IonCol>
          <IonCol size-xs="12" size-md="8">
            <p className='textRecuperar'>
            Hemos enviado un correo con un código a la dirección que nos proporcionó, escríbalo a continuación para restablecer su contraseña.
            </p>
          </IonCol>
        </IonRow>
        <IonRow>
          <IonCol size-md="2"></IonCol>
          <IonCol size-xs="12" size-md="8">
            <form action="">

              <IonItem className='itemRecuperar' no-lines>
                <IonLabel position="stacked" className='labelRecuperar'>Código</IonLabel>
                <IonInput type="number" placeholder="Ingrese código" className="inputRecuperar" autofocus></IonInput>
                <IonNote slot="error">Invalid email</IonNote>
              </IonItem>

              <IonButton expand="block" className='submitBtnInicioSesion' type='submit'>Enviar</IonButton>
            </form>
          </IonCol>
          <IonCol size-xs="12" size-md="12">
              <div className='DivLinkEnviarNuevo'> 
                <Link to="/recuperar" className='linkEnviarNuevo'>Enviar un nuevo código</Link>
              </div>
          </IonCol>
        </IonRow>
      </IonGrid>
    </IonContent>
  );
};

export default Recuperar2;
